// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#DA322A", // Primary -> Main
        contrast: "#ffffff", // None, look at primary button text color
        light: "#F6372E", // Primary -> Light
        dark: "#97110A", // Primary -> Dark
    },
    secondary: {
        main: "#58595B", // Secondary -> Main
        contrast: "#ffffff", // None, look at secondary button text color
        light: "#939393", // Secondary -> Light
        dark: "#3A3B3D", // Secondary -> Dark
    },
    tertiary: {
        main: "#000000", // Tertiary -> Main
        contrast: "#ffffff", // None, look at tertiary button text color
        light: "#DFDFDF", // Tertiary -> Light
        dark: "#212121", // Tertiary -> Dark
    },
    common: {
        border: "#E6E6E6", // Black & White -> Border
        borderLight: "#F7F7F7", // Black & White -> Border Light
        borderDark: "#979797", // Gray Shades -> Main
        accent: "#F7F7F7", // Gray Shades -> Light
        accentContrast: "#212121", // Text Color -> Main
        accentContrastLight: "#939393", // Gray Shades -> Main
        background: "#ffffff", // None, look at website background color
        backgroundContrast: "#212121", // Text Color -> Main
        disabled: "#DFDFDF", // Gray Shades -> Light
        disabledDark: "#58595B", // Gray Shades -> Mid
    },
    text: {
        main: "#212121", // Text Color -> Main
        accent: "#58595B", // Text Color -> Accent
        disabled: "#212121", // Gray Shades -> Main
        link: "#DA322A", // Primary -> Main
        linkHover: "#58595B", // Primary -> Dark
        linkAlt: "#212121", // Text Color -> Main
        linkAltHover: "#97110A", // Primary -> Main
        input: "#212121", // Text Color -> Main
    },
    success: {
        main: "#028526", // Alerts/Contrast -> Success
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#d1eedd", // Alerts/Light -> Success
    },
    warning: {
        main: "#F5AE23", // Alerts/Contrast -> Warning
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "", // Alerts/Light -> Warning
    },
    danger: {
        main: "#df1642", // Alerts/Contrast -> Error
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "", // Alerts/Light -> Error
    },
    info: {
        main: "#4688F1", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "", // Alerts/Light -> Info
    },
    neutral: {
        main: "#666666", // None
        contrast: "#ffffff", // None
        light: "#e0e0e0", // None
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#0f0f0f", // None
        hover: "#97110A", // Primary -> Dark
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#666666", // None, look at header search field text color
        disabled: "#212121", // Text Color -> Disabled
    },
    button: {
        disabled: {
            main: "#cccccc", // None
            contrast: "#939393", // None
        },
    },
    header: {
        main: "#DA322A", // None, look at header background color
        contrast: "#ffffff", // Text Color -> Main
        hover: "#ffffff", // Primary -> Dark
        accent: "#ffffff", // Primary -> Main
        accentHover: "#ffffff", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#DA322A", // None, look at main navigation background color
            contrast: "#212121", // Text Color -> Main
            hover: "#DA322A", // Primary -> Main
            underline: "#DA322A", // Primary -> Main
            accent: "#DA322A", // Primary -> Main
            accentContrast: "#ffffff", // None, should match "primary.contrast"
            accentHover: "#DA322A", // Primary -> Main
            separator: "#e1e2e7", // Border -> Border
            border: "#F7F7F7", // Black & White -> Border
        },
        secondaryNavigation: {
            main: "#212121", // Primary -> Main
            contrast: "#ffffff", // None, should match "primary.contrast"
            hover: "#ffffff", // None, should match "primary.contrast"
        },
    },
    footer: {
        main: "#000000", // Gray Shades -> Light
        contrast: "#ffffff", // Text Color -> Main
        alt: "#3A3B3D", // Primary -> Main
        altContrast: "#ffffff", // None, should match "primary.contrast"
    },
    swatch: {
        main: "#F7F7F7", // Black & White -> Border
        contrast: "#ffffff", // Text Color -> Main
        hover: "#3A3B3D", // Primary -> Main
        selected: "#3A3B3D", // Primary -> Main
        selectedHover: "#ffffff", // Primary -> Dark
    },
};

export default colors;
